import { Injectable      } from '@angular/core';
import { UtilsManager    } from 'src/app/managers/utils/utils.manager';
import { NotifierManager } from 'src/app/managers/notifier/notifier.manager';
import { Notifier        } from 'src/app/enums/notifier/notifier.enum';
import { NotifierMessage } from 'src/app/enums/notifier/message/notifier.enum';
import { RequestManager  } from 'src/app/managers/request/request.manager';
import { ErrorManager    } from 'src/app/managers/error/error.manager';
import { Service         } from 'src/app/beans/service/service.bean';
import { ServiceDetail   } from 'src/app/beans/service/service.detail.bean';

@Injectable
({
  providedIn: 'root'
})

export class ServiceHandler
{
    constructor
    (

      private _utils    : UtilsManager    ,
      private _notifier : NotifierManager ,
      private _request  : RequestManager  ,
      private _error    : ErrorManager    ,

    ) {}

    async list( token: string, siteId: number, enabled: number)
    {      

        if ( !this._utils.checker().isValidText( token ) ) 
        {
          this._notifier.show
          ( 
            Notifier.WARNING, 
            NotifierMessage.INVALID_PASSWORD
          )
          return undefined
        } 

        if ( !this._utils.checker().isValidId( siteId ) ){
          this._notifier.show
          ( 
            Notifier.WARNING, 
            NotifierMessage.INVALID_SITE_ID
          )
          return undefined
        }

        try
        {
          const response = await this._request.service().list( token, siteId, enabled ).toPromise()

          if ( this._error.hasError( response ) )
          {
            // MANAGE ERROR
            return this._error.handleCQWebapp ( response ) 
          }

          return response as Service[]

        }catch( error )
        {
          // this._error.handleNetwork ( error )  
          return undefined
        }
    }

    async getDetail( token: string, siteId: number, serviceId: number )
    {      

        if ( !this._utils.checker().isValidText( token ) ) 
        {
          this._notifier.show
          ( 
            Notifier.WARNING, 
            NotifierMessage.INVALID_PASSWORD
          )
          return undefined
        } 

        if ( !this._utils.checker().isValidId( siteId ) ){
          this._notifier.show
          ( 
            Notifier.WARNING, 
            NotifierMessage.INVALID_SITE_ID
          )
          return undefined
        }

        if ( !this._utils.checker().isValidId( serviceId ) ){
          this._notifier.show
          ( 
            Notifier.ERROR                    , 
            NotifierMessage.INVALID_SERVICE_ID
          )
          return undefined
        }

        try
        {
          const response: any = await this._request.service().getDetail( token, siteId, serviceId ).toPromise()             
          if ( this._error.hasError( response ) )
          {
            // MANAGE ERROR
            return this._error.handleCQWebapp ( response ) 
          }

          return response

        }catch( error )
        {
          // this._error.handleNetwork ( error )  
          return undefined
        }
    }

    async getServiceMin( token: string, siteId: number )
    {      

        if ( !this._utils.checker().isValidText( token ) ) 
        {
          this._notifier.show
          ( 
            Notifier.WARNING, 
            NotifierMessage.INVALID_PASSWORD
          )
          return undefined
        } 

        if ( !this._utils.checker().isValidId( siteId ) ){
          this._notifier.show
          ( 
            Notifier.WARNING, 
            NotifierMessage.INVALID_SITE_ID
          )
          return undefined
        }

        try
        {
          const response = await this._request.service().getServiceMin( token, siteId).toPromise()

          if ( this._error.hasError( response ) )
          {
            // MANAGE ERROR
            return this._error.handleCQWebapp ( response ) 
          }

          return response

        }catch( error )
        {
          // this._error.handleNetwork ( error )  
          return undefined
        }
    }

    async getCategory( token: string )
    {      
        if ( !this._utils.checker().isValidText( token ) ) 
        {
          this._notifier.show
          ( 
            Notifier.WARNING, 
            NotifierMessage.INVALID_PASSWORD
          )
          return undefined
        } 

        try
        {
          const response = await this._request.service().getCategory( token ).toPromise()

          if ( this._error.hasError( response ) )
          {
            // MANAGE ERROR
            return this._error.handleCQWebapp ( response ) 
          }

          return response as Service[]

        }catch( error )
        {
          // this._error.handleNetwork ( error )  
          return undefined
        }
    }

    async calendar( token: string, serviceId: number )
    {      
        if ( !this._utils.checker().isValidText( token ) ) 
        {
          this._notifier.show
          ( 
            Notifier.WARNING, 
            NotifierMessage.INVALID_PASSWORD
          )
          return undefined
        } 

        if ( !this._utils.checker().isValidId( serviceId ) ){
          this._notifier.show
          ( 
            Notifier.WARNING, 
            NotifierMessage.INVALID_SERVICE_ID
          )
          return undefined
        }

        try
        {
          const response = await this._request.service().calendar( token, serviceId ).toPromise()

          if ( this._error.hasError( response ) )
          {
            // MANAGE ERROR
            return this._error.handleCQWebapp ( response ) 
          }

          return response as Service[]

        }catch( error )
        {
          // this._error.handleNetwork ( error )  
          return undefined
        }
    }

    async deleteTime( token: string, serviceId: number, calendarId: number, timeId: number )
    {      

        if ( !this._utils.checker().isValidText( token ) ) 
        {
          this._notifier.show
          ( 
            Notifier.WARNING, 
            NotifierMessage.INVALID_PASSWORD
          )
          return undefined
        } 

        if ( !this._utils.checker().isValidId( serviceId ) ){
          this._notifier.show
          ( 
            Notifier.WARNING, 
            NotifierMessage.INVALID_SERVICE_ID
          )
          return undefined
        }

        if ( !this._utils.checker().isValidId( calendarId ) ){
          this._notifier.show
          ( 
            Notifier.WARNING, 
            NotifierMessage.INVALID_CALENDAR_ID
          )
          return undefined
        }

        if ( !this._utils.checker().isValidId( timeId ) ){
          this._notifier.show
          ( 
            Notifier.ERROR                 , 
            NotifierMessage.INVALID_TIME_ID
          )
          return undefined
        }

        try
        {
          const response = await this._request.service().deleteTime( token, serviceId, calendarId, timeId ).toPromise()

          if ( this._error.hasError( response ) )
          {
            // MANAGE ERROR
            return this._error.handleCQWebapp ( response ) 
          }
          else
          {
            this._notifier.show
            ( 
              Notifier.SUCCESS            , 
              NotifierMessage.OPERATION_OK
            )
            return response
          }

        }catch( error )
        {
          // this._error.handleNetwork ( error )  
          return undefined
        }
    }

    async create( token: string, siteId: number, data: ServiceDetail )
    {      
        if ( !this._utils.checker().isValidText( token ) ) 
        {
          this._notifier.show
          ( 
            Notifier.WARNING, 
            NotifierMessage.INVALID_PASSWORD
          )
          return undefined
        } 

        if ( !this._utils.checker().isValidId( siteId ) ){
          this._notifier.show
          ( 
            Notifier.WARNING, 
            NotifierMessage.INVALID_SITE_ID
          )
          return undefined
        }

        if ( !this._utils.checker().isValidText( data.name ) ){
          this._notifier.show
          ( 
            Notifier.WARNING, 
            NotifierMessage.INVALID_SER_NAME
          )
          return undefined
        }

        if ( data.ticket == 1 && !this._utils.checker().isValidText( data.ticketPrefix ) ){
          this._notifier.show
          ( 
            Notifier.WARNING, 
            NotifierMessage.INVALID_SER_TICKET_PREFIX
          )
          return undefined
        }

        if ( data.booking == 1 && !this._utils.checker().isValidText( data.bookPrefix ) ){
          this._notifier.show
          ( 
            Notifier.WARNING, 
            NotifierMessage.INVALID_SER_BOOK_PREFIX
          )
          return undefined
        }

        try
        {
          const response = await this._request.service().create( token, siteId, JSON.stringify(data) ).toPromise()

          if ( this._error.hasError( response ) )
          {
            // MANAGE ERROR
            return this._error.handleCQWebapp ( response ) 
          }
          else
          {
            this._notifier.show
            ( 
              Notifier.SUCCESS            , 
              NotifierMessage.OPERATION_OK
            )
            return response
          }

        }catch( error )
        {
          // this._error.handleNetwork ( error )  
          return undefined
        }
    }

    async update( token: string, siteId: number, serviceId: number, data: ServiceDetail )
    {      
        if ( !this._utils.checker().isValidText( token ) ) 
        {
          this._notifier.show
          ( 
            Notifier.WARNING, 
            NotifierMessage.INVALID_PASSWORD
          )
          return undefined
        }

        if ( !this._utils.checker().isValidId( siteId ) ){
          this._notifier.show
          ( 
            Notifier.WARNING, 
            NotifierMessage.INVALID_SITE_ID
          )
          return undefined
        }

        if ( !this._utils.checker().isValidId( serviceId ) ){
          this._notifier.show
          ( 
            Notifier.WARNING, 
            NotifierMessage.INVALID_SERVICE_ID
          )
          return undefined
        }

        if ( !this._utils.checker().isValidText( data.name ) ){
          this._notifier.show
          ( 
            Notifier.WARNING, 
            NotifierMessage.INVALID_SER_NAME
          )
          return undefined
        }

        if ( data.ticket == 1 && !this._utils.checker().isValidText( data.ticketPrefix ) ){
          this._notifier.show
          ( 
            Notifier.WARNING, 
            NotifierMessage.INVALID_SER_TICKET_PREFIX
          )
          return undefined
        }

        if ( data.booking == 1 && !this._utils.checker().isValidText( data.bookPrefix ) ){
          this._notifier.show
          ( 
            Notifier.WARNING, 
            NotifierMessage.INVALID_SER_BOOK_PREFIX
          )
          return undefined
        }

        try
        {
          const response = await this._request.service().update( token, siteId, serviceId, JSON.stringify(data) ).toPromise()

          if ( this._error.hasError( response ) )
          {
            // MANAGE ERROR
            return this._error.handleCQWebapp ( response ) 
          }
          else
          {
            this._notifier.show
            ( 
              Notifier.SUCCESS            , 
              NotifierMessage.OPERATION_OK
            )
            return response
          }

        }catch( error )
        {
          // this._error.handleNetwork ( error )  
          return undefined
        }
    }

    async updateCalendar( token: string, serviceId: number, calendarId: number, dow: number, open: string, close: string )
    {      
        if ( !this._utils.checker().isValidText( token ) ) 
        {
          this._notifier.show
          ( 
            Notifier.WARNING                  , 
            NotifierMessage.INVALID_PASSWORD
          )
          return undefined
        } 

        if ( !this._utils.checker().isValidId( serviceId ) ){
          this._notifier.show
          ( 
            Notifier.WARNING, 
            NotifierMessage.INVALID_SERVICE_ID
          )
          return undefined
        }

        if ( !this._utils.checker().isValidDow( dow ) ){
          this._notifier.show
          ( 
            Notifier.WARNING, 
            NotifierMessage.INVALID_CALENDAR_DOW
          )
          return undefined
        }

        if ( !this._utils.checker().isValidText( open ) ){
          this._notifier.show
          ( 
            Notifier.WARNING, 
            NotifierMessage.INVALID_CALENDAR_OPEN
          )
          return undefined
        }

        if ( !this._utils.checker().isValidText( close ) ){
          this._notifier.show
          ( 
            Notifier.WARNING, 
            NotifierMessage.INVALID_CALENDAR_CLOSE
          )
          return undefined
        }

        const open_time   = this._utils.time().timeToDate  (open  )
        const close_time  = this._utils.time().timeToDate  (close )
        
        if ( close_time < open_time ){
          this._notifier.show
          ( 
            Notifier.WARNING, 
            NotifierMessage.INVALID_CALENDAR_TIME
          )
          return undefined
        }

        
        try
        {
          const response = await this._request.service().updateCalendar( token, serviceId, calendarId, dow, open, close ).toPromise()

          if ( this._error.hasError( response ) )
          {
            // MANAGE ERROR
            return this._error.handleCQWebapp ( response ) 
          }
          else 
          {
            this._notifier.show
            ( 
              Notifier.SUCCESS            , 
              NotifierMessage.OPERATION_OK
            )
            return response
          }

        }catch( error )
        {
          // this._error.handleNetwork ( error )  
          return undefined
        }
    }

    async changeStatus( token: string, serviceId: number )
    {      
        if ( !this._utils.checker().isValidText( token ) ) 
        {
          this._notifier.show
          ( 
            Notifier.WARNING, 
            NotifierMessage.INVALID_PASSWORD
          )
          return undefined
        } 

        if ( !this._utils.checker().isValidId( serviceId ) ){
          this._notifier.show
          ( 
            Notifier.WARNING, 
            NotifierMessage.INVALID_SERVICE_ID
          )
          return undefined
        }

        try
        {
          const response = await this._request.service().changeStatus( token, serviceId ).toPromise()

          if ( this._error.hasError( response ) )
          {
            // MANAGE ERROR
            return this._error.handleCQWebapp ( response ) 
          }
          else
          {
            this._notifier.show
            ( 
              Notifier.SUCCESS            , 
              NotifierMessage.OPERATION_OK
            )
            return response
          }

        }catch( error )
        {
          // this._error.handleNetwork ( error )  
          return undefined
        }
    }

    async calendarStatus( token: string, serviceId: number, calendarId: number, timeId: number, enabled: number )
    {      
        if ( !this._utils.checker().isValidText( token ) ) 
        {
          this._notifier.show
          ( 
            Notifier.WARNING, 
            NotifierMessage.INVALID_PASSWORD
          )
          return undefined
        } 

        if ( !this._utils.checker().isValidId( serviceId ) ){
          this._notifier.show
          ( 
            Notifier.WARNING, 
            NotifierMessage.INVALID_SERVICE_ID
          )
          return undefined
        }

        if ( !this._utils.checker().isValidId( calendarId ) ){
          this._notifier.show
          ( 
            Notifier.WARNING, 
            NotifierMessage.INVALID_CALENDAR_ID
          )
          return undefined
        }

        try
        {
          const response = await this._request.service().calendarStatus( token, serviceId, calendarId, timeId, enabled ).toPromise()

          if ( this._error.hasError( response ) )
          {
            // MANAGE ERROR
            return this._error.handleCQWebapp ( response ) 
          }
          else
          {
            this._notifier.show
            ( 
              Notifier.SUCCESS            , 
              NotifierMessage.OPERATION_OK
            )
            return response
          }

        }catch( error )
        {
          // this._error.handleNetwork ( error )  
          return undefined
        }
    }
}

